import React, { Component } from 'react';
import {
  Accordion,
  AccordionItem,
} from 'react-sanfona';

import ReceiptsList from '../../../../pages/Tracking/components/Details/Receipts';

import './styles.css';

class Receipts extends Component {
  render() {
    const {
      currentManifest,
    } = this.props;

    return (
      <div className="ManifestsInTransit__Receipts">
        <Accordion
          duration={0}
        >
          {currentManifest && currentManifest.deliveries.map(({
            numCTe,
            documents,
            tmsId,
            cnpjEmit,
          }) => (
            <AccordionItem
              key={numCTe}
              className="NFTooltip__accordion-item"
              bodyClassName="NFTooltip__accordion-item-body NFTooltip__accordion-item-outside"
              title={`CTE-${numCTe}`}
              expanded
            >
              <Accordion
                duration={0}
              >
                {
                  documents.map(document => (
                    <AccordionItem
                      key={document.nf}
                      className="NFTooltip__accordion-item"
                      bodyClassName="NFTooltip__accordion-item-body NFTooltip__accordion-item-outside"
                      title={`NF-${document.nf}-${document.nfGroup}`}
                      expanded
                    >
                      <ReceiptsList
                        nfData={{ ...document, tms: { tmsId }, cnpjEmit }}
                      />
                    </AccordionItem>
                  ))
                }
              </Accordion>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    );
  }
}

export default Receipts;
